import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 6h2v12H6zm3.5 6l8.5 6V6z"
}), 'SkipPrevious');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SkipPrevious.js
// module id = 6268
// module chunks = 2